import React, { useContext } from 'react';
import { Switch, Route } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout';
import Topbar from '../components/Layout/Topbar';
import Alarm from '../components/Pages/Alarm/Alarm';
import BlankPage from '../components/Pages/BlankPage';
import Device from '../components/Pages/Device/Device';
import Product from '../components/Pages/Product/Product';



function Application(props) {

  return (<React.Fragment>
    <Topbar />
    <MainLayout> 


    <Switch>
      <Route exact path="/" component={BlankPage} />
      <Route exact path="/alarm" component={Alarm} />
      <Route exact path="/device" component={Device} />
      <Route exact path="/products" component={Product} />
      {/* <Route exact path="/app" component={BlankPage} />
      <Route path="/app/dashboard" component={DashboardPage} />
      <Route path="/app/form" component={Form} />
      <Route path="/app/table" component={Table} />
      <Route path="/app/page-list" component={Parent} />
      <Route path="/app/pages/not-found" component={NotFound} />
      <Route path="/app/pages/error" component={Error} />
      <Route path="/app/category" component={BlankPage} />
      <Route component={NotFound} /> */}
    </Switch>
    </MainLayout>
  </React.Fragment>
  );
}


export default Application;
